export const aliRoutes = [
  {
    path: '/ali/fee',
    name: 'AliFee',
    component: () => import('@/views/home/ali/Fee'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/ali/bind',
    name: 'AliBind',
    component: () => import('@/views/home/ali/Bind'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/ali/order',
    name: 'AliOrder',
    component: () => import('@/views/home/ali/Bind'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/ali/parcel',
    name: 'AliParcel',
    component: () => import('@/views/home/ali/Bind'),
    meta: {
      noAuth: true
    }
  },
]
